import { isNil } from 'lodash';
import { useContext } from 'react';
import userService from 'services/userService';
import StoreContext from 'stores/context/StoreContext';
import useSWR from 'swr';
import type { AxiosError } from 'axios';
import type { User } from 'models/user/user';
import type { SWRResponse } from 'swr';

export const SWR_CURRENT_USER_ENDPOINT = 'current-user';

const useCurrentUser = (load = true): SWRResponse<User, AxiosError> => {
  const { userStore } = useContext(StoreContext);
  const userId = userStore.userData?.id;

  return useSWR(
    !isNil(load) && load && !isNil(userId) ? [SWR_CURRENT_USER_ENDPOINT, userId] : null,
    async ([_, id]) => await userService.getUserAsync(id)
  );
};

export default useCurrentUser;
